import { AddFavoriteChannel, RemoveFavoriteChannel } from '@tableau/search-microview-communication-channels/lib/src/FavoriteChannel';

import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { Favorites } from '~src/favorites/resources/Favorites';
import { FavoriteRepresentation, FavoritesResource } from '~src/favorites/resources/FavoritesResource';
import { FavoriteItemType } from '~src/favorites/types/IFavorite';

export function startListening(): () => void {
    const unsubscribeAddFavoriteListener = startListeningToAddFavoriteListener();
    const unsubscribeRemoveFavoriteListener = startListeningToRemoveFavoriteListener();

    return () => {
        unsubscribeAddFavoriteListener();
        unsubscribeRemoveFavoriteListener();
    };
}

export function startListeningToAddFavoriteListener(): () => void {
    const favoriteChannel = new AddFavoriteChannel();
    const stopListeningToFavoriteChannel = favoriteChannel.listen(request => {
        return new Promise<void>((resolve, reject) => {
            if (!MicroviewContentToVPC[request.contentType]) {
                reject();
            }

            const item = {
                contentType: MicroviewContentToVPC[request.contentType],
                contentId: request.id
            } as FavoriteRepresentation;

            if(FeatureFlags.crassFavorites && item.contentType === 'metric') {
                const userId = SessionUserSelectors.sessionUserId(getAppStore().getState());
                FavoritesResource.add(item, userId)
                    .then(() => { resolve(); })
                    .catch((e) => { reject(e); });
            } else {
                Favorites.add(item.contentId, item.contentType as FavoriteItemType)
                    .then(() => { resolve(); })
                    .catch((e) => { reject(e); });
            }
        });
    });

    return () => {
        stopListeningToFavoriteChannel();
    };
}

export function startListeningToRemoveFavoriteListener(): () => void {
    const favoriteChannel = new RemoveFavoriteChannel();
    const stopListeningToFavoriteChannel = favoriteChannel.listen(request => {
        return new Promise<void>((resolve, reject) => {
            if (!MicroviewContentToVPC[request.contentType]) {
                reject();
            }

            const item = {
                contentType: MicroviewContentToVPC[request.contentType],
                contentId: request.id
            } as FavoriteRepresentation;

            if(FeatureFlags.crassFavorites && item.contentType as any === 'metric') {
                const userId = SessionUserSelectors.sessionUserId(getAppStore().getState());
                FavoritesResource.remove(item, userId)
                    .then(() => { resolve(); })
                        .catch((e) => { reject(e); });
            } else {
                Favorites.remove(item.contentId, item.contentType as FavoriteItemType)
                    .then(() => { resolve(); })
                    .catch((e) => { reject(e); });
            }
        });
    });

    return () => {
        stopListeningToFavoriteChannel();
    };
}

export const MicroviewContentToVPC: { [key: string]: string } = {
    collection: 'collection',
    dataRole: 'dataRole',
    unifieddatasource: 'datasource',
    flow: 'flow',
    lens: 'lens',
    metric: 'metric',
    project: 'project',
    virtualconnection: 'virtualConnection',
    table: 'virtualConnectionTable',
    view: 'view',
    workbook: 'workbook',
    predictiveModel: 'predictiveModel',
};
